<template>
  <li
    aria-haspopup="true"
    data-menu-toggle="hover"
    class="menu-item menu-item-submenu"
    v-bind:class="{ 'menu-item-open': hasActiveChildren(to) }"
  >
    <a
      v-ripple
      href="#"
      class="menu-link menu-toggle dark sub-menu-parent"
    >
      <i v-if="icon" :class="['menu-icon', icon, 'sub-menu-parent']"></i>
      <span
        class="menu-text font-weight-bolder sub-menu-parent"
        style="color: #000000"
      >
        {{ title }}
        <v-badge
          v-if="counter_key"
          icon="bell-outline"
          :content="counter[counter_key] > 99 ? '99+' : counter[counter_key]"
          :value="counter[counter_key] > 0"
          color="#f00"
          overlap
          offset-x="-6"
          offset-y="9"
        >
        </v-badge>
      </span>
      <i class="menu-arrow sub-menu-parent"></i>
    </a>

    <div class="menu-submenu">
      <span class="menu-arrow"></span>
      <ul class="menu-subnav navi navi-accent navi-hover navi-bold">
        <li aria-haspopup="true" class="menu-item menu-item-parent">
          <span class="menu-link">
            <span class="menu-text">{{ title }}</span>
          </span>
        </li>
        <template v-for="(groupItem, index) in submenu">
          <nav-menu-group
            :key="'submenu' + index"
            v-if="groupItem.submenu"
            :to="groupItem.url"
            :title="groupItem.title"
            :icon="groupItem.icon"
            :submenu="groupItem.submenu"
            :counter_key="groupItem.counter_key || null"
            :counter="counter"
          ></nav-menu-group>
          <nav-menu-item
            v-else
            :key="'submenu' + index + groupItem.title"
            :to="to + groupItem.url"
            :title="groupItem.title"
            :icon="groupItem.title"
            :submenu="true"
            :counter_key="groupItem.counter_key || null"
            :counter="counter"
          />
        </template>
      </ul>
    </div>
  </li>
</template>
<script>
import NavMenuItem from "./MenuItem";

export default {
  name: "nav-menu-group",
  props: {
    to: {
      type: String
    },
    title: {
      type: String
    },
    icon: {
      type: String,
      default: null
    },
    submenu: {
      type: Array,
      default: null
    },
    counter_key: {
      type: String,
      default: null
    },
    counter: {
      type: Object
    }
  },
  components: {
    NavMenuItem
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
